import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormField, FormFieldConst, FormFieldType, TypeModal } from './modal-form.const';
import { ModalType } from '../modal.const';
import * as _ from 'lodash';
import { UploadService } from '../../../common/services/Upload.service';
import { CommonService } from '../../../common/services/Common.service';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from '../../base.component';
import { BsModalService } from 'ngx-bootstrap';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

@Component({
  selector: 'app-modal-form',
  templateUrl: './modal-form.component.html',
  styleUrls: ['./modal-form.component.css'],
  providers: [UploadService, CommonService, ToastrService],
})
export class ModalFormComponent extends BaseComponent implements OnChanges {
  @Input() triggerAdvancedFilter: boolean = false;
  @Input() isFooter: boolean = true;
  @Input() type: any = TypeModal.Default;
  @Input() content: any = { type: ModalType.Primary, title: 'Modal' };
  @Input() formFields: FormField[] = [];
  @Input() message: { class: string; content: string } | null = null;
  @Input() validate_callback: Function = undefined;
  @Input() showHeader: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() hideFields: string[] = [];
  @Input() isCreate: boolean = true;
  @Input() modal: string = 'create';
  @Output() onCloseModal = new EventEmitter<any>();
  @Output() onChangeValue = new EventEmitter<{ key: any; model: any }>();
  @Output() onSubmit = new EventEmitter<any>();
  @Output() onAttachFile = new EventEmitter<any>();
  @Output() onDeleteFile = new EventEmitter<any>();
  @Output() onRemoveField = new EventEmitter<any>();
  @Output() onReloadField = new EventEmitter<any>();
  //
  @Input() typeFilter: any = 'ticket';
  @Output() onSubmitFilter = new EventEmitter<any>();
  public readonly TypeModal = TypeModal;
  protected arrShow = [];
  protected textEditorContent = '';
  protected formModel = {};
  protected fileAttach = false;
  protected fileAttachKey = '';
  protected listFileAttach: any[] = [];
  protected readonly FormFieldConst = FormFieldConst;
  protected readonly FormFieldType = FormFieldType;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private commonService: CommonService,
    private uploadService: UploadService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {
    await this.mapFieldModel();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.formFields && !changes.formFields.firstChange) {
      await this.mapFieldModel();
    }
  }

  async mapFieldModel() {
    this.formFields
      .map(res => {
        this.formModel = {
          ...this.formModel,
          [res.key]: res.value,
        };
        if (res.type == FormFieldType.Hidden) {
          this.arrShow[res.key] = true;
        } else if (res.type == FormFieldType.TextEditor) {
          this.textEditorContent = res.value;
        } else if (res.type == FormFieldType.FileAttach) {
          this.fileAttach = true;
          this.fileAttachKey = res.key;
          if (res.value) {
            this.listFileAttach = res.value.split(',');
          }
        }
      })
      .sort((a: any, b: any) => a.order - b.order);
  }

  async changeValue(item: any, value: any) {
    if (!item.blockEventChanged) {
      await this.onChangeValue.emit({ key: item.key, model: this.formModel });
    }
    // await this.mapFieldModel()
  }

  async changeInputValue(item: any, $event) {
    let value = $event.target.value;
    if (typeof value === 'string') {
      value = value.trim();
    }
    this.formModel[item.key] = value;
    await this.changeValue(item, value);
  }

  async changeCheckBoxValue(item: any, $event) {
    const value = $event.target.value;
    if (!this.formModel[item.key]) {
      this.formModel[item.key] = [];
    }

    if (this.formModel[item.key].length > 0) {
      if (!this.formModel[item.key].includes(value)) {
        this.formModel[item.key] = [...this.formModel[item.key], value];
      } else {
        this.formModel[item.key] = this.formModel[item.key].filter(v => v !== value);
      }
    } else {
      this.formModel[item.key] = [value];
    }
    await this.changeValue(item, value);
  }

  async changeSwitchValue(item: any, $event) {
    const value = $event.target.value;
    const checked = $event.target.checked;
    this.formModel[item.key] = !!checked;
    await this.changeValue(item, value);
  }
  async changeRadioValue(item: any, value: any) {
    this.formModel[item.key] = value;
    await this.changeValue(item, value);
  }

  async changeValueSelect(item: any, $event) {
    this.formModel[item.key] = $event.target.value;
    await this.changeValue(item, $event.target.value);
  }

  async changeValueSelect2(item: any, $event) {
    let value = $event.value;
    if (value === '-1' || value === 'Chọn') {
      value = null;
    }
    this.formModel[item.key] = value;
    await this.changeValue(item, $event.value);
  }

  async changeValueBs(item: any, $event) {
    let value = $event;
    if (value && value.toString().includes('Indochina Time')) {
      value = moment(value).utc(true).toISOString();
    } else if (value) {
      value = moment(value).utc(false).toISOString();
    }
    this.formModel[item.key] = value;
    await this.changeValue(item, value);
  }

  attachFile(key, $event) {
    const files = $event.srcElement.files;
    const fileSize = files[0] ? files[0].size : 0;
    if (fileSize > 5242880) {
      this.throwError('Lỗi, dung lượng file vượt quá 5Mb');
    } else {
      this.uploadService.upload(files[0]).then((res: any) => {
        if (!res.error) {
          this.listFileAttach.push(this.commonService.file(res.data));
          this.formModel[key] = this.listFileAttach.join(',');
          $event.target.value = null;
        } else {
          this.throwError(res.data.message);
        }
      });
    }
  }

  deleteFile(key, file) {
    this.listFileAttach = _.pull(this.listFileAttach, file);
    this.formModel[key] = this.listFileAttach.join(',');
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  removeField(item) {
    this.onRemoveField.emit({ key: item.key });
  }

  reloadField(item) {
    this.onReloadField.emit({ key: item.key });
  }

  submit() {
    const nullValidations = this.formFields.filter(item => item.required);
    const validations = this.formFields.map(item => item);
    if (nullValidations.length > 0) {
      for (const v of nullValidations) {
        let data = this.formModel[v.key];
        if (typeof data === 'number') {
          data = data.toString();
        }
        if (_.isEmpty(data)) {
          this.message = {
            class: 'alert dark alert-danger',
            content: `${v.label} không được để trống!`,
          };
          setTimeout(() => {
            this.message = null;
          }, 3000);
          return;
        }
      }
    }
    if (this.validate_callback && validations.length > 0) {
      for (const v of validations) {
        const { valid, message } = this.validate_callback(this.formModel[v.key], v.key);
        if (!valid) {
          this.message = { class: 'alert dark alert-danger', content: message };
          setTimeout(() => {
            this.message = null;
          }, 3000);
          return;
        }
      }
    }
    if (!this.message) {
      if (this.triggerAdvancedFilter) {
        let advancedFilterDoc = document.getElementById('advanced-filter-submit');
        if (advancedFilterDoc) {
          advancedFilterDoc.click();
        }
      }

      this.onSubmit.emit({ model: this.formModel });
    }
  }

  triggerChangeEvent(event: MouseEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    });
    inputElement.dispatchEvent(changeEvent);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/modal-form-template/modal-form.component.ts